import { render } from "./ProductMediaGalleryV2.vue?vue&type=template&id=5323c362&scoped=true"
import script from "./ProductMediaGalleryV2.vue?vue&type=script&lang=js"
export * from "./ProductMediaGalleryV2.vue?vue&type=script&lang=js"

import "./ProductMediaGalleryV2.vue?vue&type=style&index=0&id=5323c362&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/rb-redev/rb-redev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5323c362"]])

export default __exports__